import React from "react";
import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import Typography from "@mui/material/Typography";

const scratchPayLogo = "/assets/icons/scratchpay.png";

interface IScratchPayPaymentCard {
  isSelected: boolean;
  isEligible: boolean;
  enrollmentText: string;
  prequalifiedLabel?: string;
  handleCardClick: () => void;
}

const ScratchPayPaymentCard = ({
  isSelected,
  isEligible,
  handleCardClick,
  enrollmentText,
  prequalifiedLabel,
}: IScratchPayPaymentCard) => {
  const handleClick = () => {
    if (isEligible) {
      handleCardClick();
    }
  };

  const borderClass = !isEligible ? "border-[#908E8D]" : isSelected ? "border-violet-1" : "border-taupe-50";

  return (
    <Box
      role="button"
      aria-pressed={isSelected}
      onClick={handleClick}
      className={`relative w-full rounded-lg ${prequalifiedLabel ? "min-h-[88px]" : "h-[88px]"}
        bg-white border ${borderClass}
        ${isEligible ? "cursor-pointer" : "cursor-not-allowed opacity-50"}`}
      sx={{ transition: "border-color 0.2s ease-in-out" }}
    >
      <span
        className="absolute -top-2.5 right-4 rounded-full bg-[#637AE2] px-2.5 py-0.5
        text-[10px] font-semibold text-white"
      >
        Most Popular
      </span>
      <Box className="flex items-center gap-4 pl-3 pr-4 py-4 h-full">
        <Radio
          checked={isSelected}
          disabled={!isEligible}
          className={`!p-0 ${isSelected ? "!text-violet-1" : "!text-taupe-50"}`}
          sx={{ width: 24, height: 24 }}
        />
        <Box className="flex-1 min-w-0 relative">
          <Box className="flex items-center gap-2">
            <Typography
              sx={{
                color: "black.main",
                fontFamily: "geograph-medium, sans-serif",
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: 500,
              }}
            >
              Monthly
            </Typography>
            <Box className="flex items-center">
              <span className="text-[10px] text-black-main font-semibold">Powered by</span>
              <img
                src={scratchPayLogo}
                alt="ScratchPay"
                className="h-3 w-auto object-contain"
              />
            </Box>
          </Box>
          <Typography
            sx={{
              color: "#908E8D",
              fontFamily: "geograph-regular, sans-serif",
              fontSize: "12px",
              lineHeight: "18px",
              fontWeight: 400,
              marginTop: "0px",
            }}
          >
            {enrollmentText}
          </Typography>
          {prequalifiedLabel ? (
            <Typography
              sx={{
                color: "#1D7A6E",
                fontFamily: "geograph-medium, sans-serif",
                fontSize: "11px",
                lineHeight: "16px",
                fontWeight: 500,
              }}
            >
              {prequalifiedLabel}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

export default ScratchPayPaymentCard;
